<template>
    <div>
        <v-dialog
            @keydown.esc="close"
            v-model="dialog"
            width="500px"
            min-height="200px"
        >
            <v-card>
                <v-card-title class="text-h6 lighten-5 pb-10">
                    <span class="titletxt">Colunas disponíveis</span>
                    <v-spacer></v-spacer>
                    <v-btn v-on:click="close" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex
                            xs6
                            v-for="column in columns"
                            :key="column.value"
                        >
                            <v-checkbox
                                class="pa-0 ma-0"
                                :label="column.name"
                                v-model="showColumns[column.value]"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions class="pb-10">
                    <v-spacer />
                    <Button
                        label="OK"
                        color="primary"
                        height="40px"
                        style="border-radius: 3px"
                        width="100px"
                        v-on:click.native="defineColumns"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Button from '@/components/Button/Button'

export default {
    name: 'ModalColumnDefinition',
    props: {
        ActionButton: {
            type: Function,
            require: false
        },
        dialog: Boolean,
        title: String,
        columns: Array,
        parentShowColumns: Object
    },
    components: {
        Button
    },
    methods: {
        close() {
            this.showColumns = this.startColumns
            this.ActionButton('close-definition')
        },
        defineColumns() {
            this.startColumns = this.showColumns
            this.ActionButton('defined-columns', this.showColumns)
        }
    },
    data(i) {
        return {
            showColumns: { ...i.parentShowColumns },
            startColumns: i.parentShowColumns
        }
    }
}
</script>
